<template>
    <div class="tab-text">
        <div class="vx-col w-1/2 mb-6 mt-3 ml-5">
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/4 w-full">
                    <span>Warehouse</span>
                </div>
                <div class="vx-col sm:w-3/4 w-full">
                    <Warehouse @selected="(val) => { this.selectedWarehouse = val }"></Warehouse>
                </div>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/4 w-full">
                    <span>Relocation Type</span>
                </div>
                <div class="vx-col sm:w-3/4 w-full">
                    <IstType @selected="(val) => { this.selectedType = val }"></IstType>
                </div>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/4 w-full">
                    <span>Transaction Date</span>
                </div>
                <div class="vx-col sm:w-3/4 w-full">
                    <vs-input class="w-full" v-model="date" type="date" v-validate="'required'"/>
                </div>
            </div>
            <div class="vx-row">
                <div class="vx-col sm:w-1/4 w-full">
                    <span></span>
                </div>
                <div class="vx-col sm:w-3/4 w-full">
                    <vs-button
                        @click="handleFilter()"
                        size="medium"
                        color="primary"
                        icon-pack="feather"
                        icon="icon-search"
                        title="Filter"
                    >Filter</vs-button>
                </div>
            </div>
        </div>

        <div class="vx-row mb-12">
            <div class="core vx-col md:w-1/1 w-full mb-base">
                <data-table
                    :draw="draw"
                    :baseUrl="baseUrl"
                    :status="9"
                    :warehouse="this.selectedWarehouse"
                    :istType="this.selectedType"
                    :date="date"
                ></data-table>
            </div>
        </div>
    </div>
</template>

<script>
import DataTable from "../DataTable";
import Warehouse from "../component/WarehouseV2.vue";
import IstType from "../component/IstType.vue";

export default {
    components: {
        DataTable,
        Warehouse,
        IstType,
    },
    data() {
        return {
            baseUrl: "api/wms/v1/inter-storage",
            draw: 0,
            date: "",
            selectedWarehouse: [],
            selectedType: [],
        };
    },
    methods: {
        handleFilter() {
            this.draw++;
        },
    },
};
</script>